var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcQrCodeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 45.0038H40C38.5 45.0038 37.5 44.0038 37.5 42.5038C37.5 41.0039 38.5 40.0039 40 40.0039H42.5C44 40.0039 45 41.0039 45 42.5038C45 44.0038 44 45.0038 42.5 45.0038Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 45.0038H27.5C26 45.0038 25 44.0038 25 42.5038C25 41.0039 26 40.0039 27.5 40.0039H32.5C34 40.0039 35 41.0039 35 42.5038C35 44.0038 34 45.0038 32.5 45.0038Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 37.5028H35C33.5 37.5028 32.5 36.5028 32.5 35.0029C32.5 33.5029 33.5 32.5029 35 32.5029H42.5C43.9999 32.5029 44.9999 33.5029 44.9999 35.0029C44.9999 36.5028 43.9999 37.5028 42.5 37.5028Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 45.0026C26 45.0026 25 44.0026 25 42.5027V35.0029C25 33.5029 26 32.5029 27.5 32.5029C29 32.5029 30 33.5029 30 35.0029V42.5027C30 44.0026 29 45.0026 27.5 45.0026Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 37.5075C41 37.5075 40 36.5075 40 35.0076V27.5077C40 26.0078 41 25.0078 42.5 25.0078C44 25.0078 45 26.0078 45 27.5077V35.0076C45 36.5075 44 37.5075 42.5 37.5075Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 30.0077H40C38.5 30.0077 37.5 29.0077 37.5 27.5077C37.5 26.0078 38.5 25.0078 40 25.0078H42.5C44 25.0078 45 26.0078 45 27.5077C45 29.0077 44 30.0077 42.5 30.0077Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30.0077H27.5C26 30.0077 25 29.0077 25 27.5077C25 26.0078 26 25.0078 27.5 25.0078H32.5C34 25.0078 35 26.0078 35 27.5077C35 29.0077 34 30.0077 32.5 30.0077Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 45.0073H4.99998C2.24999 45.0073 0 42.7574 0 40.0074V30.0077C0 27.2578 2.24999 25.0078 4.99998 25.0078H14.9999C17.7499 25.0078 19.9999 27.2578 19.9999 30.0077V40.0074C19.9999 42.7574 17.7499 45.0073 14.9999 45.0073ZM4.99998 30.0077V40.0074H14.9999V30.0077H4.99998Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 19.9995H30C27.25 19.9995 25 17.7496 25 14.9996V4.99987C25 2.24994 27.25 0 30 0H39.9999C42.7499 0 44.9999 2.24994 44.9999 4.99987V14.9996C44.9999 17.7496 42.7499 19.9995 39.9999 19.9995ZM30 4.99987V14.9996H39.9999V4.99987H30Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 19.9995H4.99998C2.24999 19.9995 0 17.7496 0 14.9996V4.99987C0 2.24994 2.24999 0 4.99998 0H14.9999C17.7499 0 19.9999 2.24994 19.9999 4.99987V14.9996C19.9999 17.7496 17.7499 19.9995 14.9999 19.9995ZM4.99998 4.99987V14.9996H14.9999V4.99987H4.99998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQrCodeWhite);
export default __webpack_public_path__ + "static/media/ic-qrCodeWhite.54547cc075781507546f0dc44562c9c9.svg";
export { ForwardRef as ReactComponent };